import AddAuthenticationMethodForm from './components/AddAuthenticationMethodForm'
import Confirm2faPage from './components/Confirm2faPage'
import ConfirmEmailPrompt from './components/ConfirmEmailPrompt'
import Enroll2faChooseMethodPage from './components/Enroll2faChooseMethodPage'
import EnterprisePlanRedeemCodeForm from './components/EnterprisePlanRedeemCodeForm'
import EnterprisePlanWelcome from './components/EnterprisePlanWelcome'
import ExtensionRedirectPage from './components/ExtensionRedirectPage'
import ImpactMetricsReportPage from './components/ImpactMetricsReport/Page'
import InternationalWaitlistBanner from './components/InternationalWaitlistBanner'
import LoginAs from './components/LoginAs'
import LoginForm from './components/LoginForm'
import LoginSignupLink from './components/LoginSignupLink'
import LoginSignupOAuthOnlyPage from './components/LoginSignupOAuthOnlyPage'
import NotificationSettingsPage from './components/NotificationSettingsPage'
import PasswordResetForm from './components/PasswordResetForm'
import Payment from './components/Payment'
import SelectPlanPage from './components/SelectPlanPage'
import SendPasswordResetForm from './components/SendPasswordResetForm'
import SignupForm from './components/SignupForm'
import SignupPage from './components/SignupPage'
import UserSettingsPage from './components/UserSettingsPage'
import { addComponentToDOMById } from './utils/component'
import { initSentry } from './utils/metrics'

import './sass/_index.scss'

try {
  initSentry()
} catch {
  // pass
}

class App {
  constructor() {
    addComponentToDOMById(
      AddAuthenticationMethodForm,
      'AddAuthenticationMethodForm',
    )
    addComponentToDOMById(Confirm2faPage, 'Confirm2faPage')
    addComponentToDOMById(ConfirmEmailPrompt, 'ConfirmEmailPrompt')
    addComponentToDOMById(
      Enroll2faChooseMethodPage,
      'Enroll2faChooseMethodPage',
    )
    addComponentToDOMById(
      EnterprisePlanRedeemCodeForm,
      'EnterprisePlanRedeemCodeForm',
    )
    addComponentToDOMById(EnterprisePlanWelcome, 'EnterprisePlanWelcome')
    addComponentToDOMById(ExtensionRedirectPage, 'ExtensionRedirectPage')
    addComponentToDOMById(ImpactMetricsReportPage, 'ImpactMetricsReportPage')
    addComponentToDOMById(
      InternationalWaitlistBanner,
      'InternationalWaitlistBanner',
    )
    addComponentToDOMById(LoginAs, 'LoginAs')
    addComponentToDOMById(LoginForm, 'LoginForm')
    addComponentToDOMById(LoginSignupOAuthOnlyPage, 'LoginSignupOAuthOnlyPage')
    addComponentToDOMById(LoginSignupLink, 'LoginSignupLink')
    addComponentToDOMById(NotificationSettingsPage, 'NotificationSettingsPage')
    addComponentToDOMById(PasswordResetForm, 'PasswordResetForm')
    addComponentToDOMById(Payment, 'Payment')
    addComponentToDOMById(SelectPlanPage, 'SelectPlanPage')
    addComponentToDOMById(SendPasswordResetForm, 'SendPasswordResetForm')
    addComponentToDOMById(SignupForm, 'SignupForm')
    addComponentToDOMById(SignupPage, 'SignupPage')
    addComponentToDOMById(UserSettingsPage, 'UserSettingsPage')
  }
}

// Always export a 'new' instance so it immediately evokes:
export default new App()
